import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClass },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [_vm._v(" " + _vm._s(_vm.subTitle) + " ")]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c(
              VCard,
              { staticClass: "mt-2" },
              [
                _c(VDataTable, {
                  staticClass: "text-center table-inca",
                  attrs: {
                    responsive: "",
                    hover: "",
                    items: _vm.items,
                    headers: _vm.headers,
                    "hide-default-footer": "",
                    "disable-pagination": "",
                    loading: _vm.isLoading,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.actions",
                      fn: function (ref) {
                        var item = ref.item
                        return [
                          item.maintenance
                            ? _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  { attrs: { icon: "" } },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v(
                                                    "mdi-information-outline"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "Este item está actualmente en mantenimiento"
                                    ),
                                  ]),
                                ]
                              )
                            : _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      name: "somos1_report_item",
                                                      "data-hash-email":
                                                        "asdad",
                                                      "data-region": "Lima",
                                                      "data-company": "032",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onVer(item)
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(VIcon, [
                                                  _vm._v("mdi-eye"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v("Haz clic para ver el reporte"),
                                  ]),
                                ]
                              ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }